import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/auth/services/auth/auth.service';

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Only attach token for requests to your backend API
    if (!req.url.startsWith(environment.API_URL)) {
      return next.handle(req);
    }

    // Convert the token promise to Observable
    return from(this.authService.getAccessToken()).pipe(
      switchMap(token => {
        if (token) {
          // Clone request and add Authorization header
          const authReq = req.clone({
            headers: req.headers.set('Authorization', `Bearer ${token}`)
          });
          return next.handle(authReq);
        }
        // No token, send request unmodified
        return next.handle(req);
      })
    );
  }
}